import React from 'react';
import Skeleton from 'react-loading-skeleton';
import { LazyImage } from "react-lazy-images";
// import { LazyLoadImage } from 'react-lazy-load-image-component';


export default class ArticleItem extends React.Component {
  render() {
    // console.log(this.props.doctor.avatar_url)
    const {scrollPosition} = this.props;
    return (
      <li>
        <a href={this.props.article.url}>
          <div className="item-content">
            <div className="item-media">
              <LazyImage
                src={this.props.article.image_url}
                alt={this.props.article.title}
                debounceDurationMs={800}
                actual={({ imageProps }) => <img {...imageProps} />}
                placeholder={({ ref }) => <div ref={ref} />}
                loading={() => (
                  <Skeleton height={110} width={130} />
                )}
                error={() => (
                  <Skeleton height={210} width={`100%`} />
                  
                )}
              />
              
            </div>
            <div className="item-inner">
              <div className="item-subtitle" dangerouslySetInnerHTML={{ __html: this.props.article.category  }}/>
              <div className="item-title" dangerouslySetInnerHTML={{ __html: this.props.article.title  }}/>
              <div className="item-subtitle bottom-subtitle">
                <LazyImage
                  src={this.props.article.doctor_avatar}
                  alt={this.props.article.reviewed_by}
                  debounceDurationMs={800}
                  actual={({ imageProps }) => <img {...imageProps} />}
                  placeholder={({ ref }) => <div ref={ref} />}
                  loading={() => (
                    <Skeleton circle={true} height={23} width={23} />
                  )}
                  error={() => (
                    <Skeleton circle={true} height={23} width={23} />
                    
                  )}
                />
                
                {this.props.article.reviewed_by}
              </div>
            </div>
          </div>
        </a>
      </li>
     
    );
  }
}

